import { render } from "./branchDetails.vue?vue&type=template&id=22d1d179"
import script from "./branchDetails.vue?vue&type=script&lang=js"
export * from "./branchDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__